import {Injectable} from '@angular/core';
import {IdTextValueModel, MesApiService} from "common-shared";
import {Observable} from "rxjs";
import {plainToInstance} from "class-transformer";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ParameterService extends MesApiService {

  constructor() {
    super('Parameter');
  }

  getAll(): Observable<IdTextValueModel[]> {
    return this.getList<IdTextValueModel[]>({action: 'GetAll'})
      .pipe(map(value => {
        return plainToInstance(IdTextValueModel, value.data);
      }));
  }

  public getParameter(id: string): Observable<IdTextValueModel> {
    return this.getSingle<IdTextValueModel>({id: id, action: 'GetParameter'})
      .pipe(map(value => {
        return plainToInstance(IdTextValueModel, value.data);
      }));
  }

  save(model: IdTextValueModel) {
    return this.update<IdTextValueModel>(model.Id, model).pipe(map(value => {
      return plainToInstance(IdTextValueModel, value.data);
    }));
  }
}

export class Parameters {
  public static SharedFilters = '73bc29d8-5ce6-49b8-b6fd-dd5f3cc28606';
}
